import { UserInfo } from "../../../models/interfaces/scores/user-info";
import { QuestionResponse } from "../../../models/interfaces/questions/question-response";
import { MskScoreLite } from "../../../models/interfaces/scores/msk-score-lite";
import { ServiceBase } from "../service-base";

// -------------------------------------------------------------------------------------------------
// #region Interfaces
// -------------------------------------------------------------------------------------------------

export interface CalculateMskLiteInput {
    userInfo: UserInfo;
    existingMskScoreLite?: MskScoreLite;
    movementResponses: QuestionResponse[];
    bodyCompositionResponses: QuestionResponse[];
    physicalActivityResponses: QuestionResponse[];
    injuryHistoryResponses: QuestionResponse[];
}

// -------------------------------------------------------------------------------------------------
// #region Service
// -------------------------------------------------------------------------------------------------

const CalculateMskLiteService = {
    /**
     * Submit responses and calculate MSK Lite score.
     * Can send partial responses - any groups not yet completed can be empty arrays.
     * The API will calculate whatever groups are provided and return the score.
     */
    score: ServiceBase.post<MskScoreLite, CalculateMskLiteInput>(
        `/calculator/msk-lite`
    ),
};

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export default CalculateMskLiteService;